/**
 * List Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asSupplyMgr');

  app.controller('ImportIndexController', [
    '$scope',
    '$window',
    '$timeout',
    'importApi',
    function($scope, $window, $timeout, importApi) {
      // select search input content on focus
      $('#search').click(function() {
        $(this).select();
      });

      $scope.list = null;
      $scope.importMessage = null;
      $scope.importDisabled = false;
      $scope.import2Disabled = false;

      $scope.page = {
        number: 0,
        size: 10,
      };

      $scope.searchTerm = '';
      $scope.loading = false;

      $scope.sort = {
        field: 'id',
        order: 'desc',
      };

      var filterTimeout = null;
      $scope.$watch('searchTerm', function(newVal, oldVal) {
        if (newVal == oldVal) {
          return;
        }

        if (filterTimeout) {
          $timeout.cancel(filterTimeout);
        }

        filterTimeout = $timeout(function() {
          $scope.page.number = 0;

          $scope.fetch();
        }, 700);
      });


      $scope.fileNameChanged = function(object){
          console.log($(object));
          $('#filename').val($(object).get(0).files[0].name);
      };

        // try saving and process server side validation errors
        $scope.submitForm = function() {
            $scope.disableButtons(800);
            $('#filename').val('File is not selected');
            $scope.error = false;
            var f = document.getElementById('file').files[0];
            var formData = new FormData();
            formData.append('file', f);
            importApi.import(formData).then(
                function(data) {
                    $scope.importMessage = data.message;
                    //$window.location.href = '/#!/demandmgr/import';
                    $scope.fetch();
                },
                function(message) {
                    $scope.error = true;
                    $scope.importMessage = message;
                    $scope.importDisabled = false;
                }
            );
        };

      $scope.getStatus = function(status) {
        return status ? 'Active' : 'Inactive';
      };

      /**
       * Fetch list data from server
       */
      $scope.fetch = function() {
        $scope.loading = true;

        importApi.getList($scope.sort, $scope.searchTerm, $scope.page).then(
          function(data) {
            $scope.list = {
              count: data.count,
              data: data.data,
              maxPage: Math.floor(data.count / $scope.page.size),
            };
            $scope.loading = false;
          },
          function() {
            $scope.list = {
              count: 0,
              data: [],
              maxPage: null,
            };
            $scope.loading = false;
          }
        );
      };

      /**
       * set page to new value and load data
       * @param page
       */
      $scope.setPage = function(page) {
        $scope.page.number = page;

        $scope.fetch();
      };

      /**
       * get the sort css for a given column
       * @param field
       * @returns {*}
       */
      $scope.getSortCssClass = function(field) {
        if ($scope.sort.field === field) {
          return 'fa-sort-' + $scope.sort.order;
        } else {
          return 'fa-sort';
        }
      };

      /**
       * update sorting and fetch data
       * @param field
       */
      $scope.setSort = function(field) {
        $scope.page.number = 0;

        if ($scope.sort.field === field) {
          $scope.sort.order = $scope.sort.order === 'desc' ? 'asc' : 'desc';
        } else {
          $scope.sort.field = field;
          $scope.sort.order = 'desc';
        }

        $scope.fetch();
      };

      $scope.showLog = function(id) {
          importApi.getDetails(id).then(
              function(data) {
                  $('#import-info-modal #import_info_title').text("ID:" + id);
                  $('#import-info-modal #log').text(data);

                  $('#import-info-modal').modal('show');
              },
              function() {
              }
          );
      };


      $scope.disableButtons = function(msec){
          $scope.importDisabled = true;
          $timeout( function(){
              $scope.importDisabled = false;
          }, msec );
      }

      $scope.startImport = function(id){
          $scope.disableButtons(800);
          var formData = new FormData();
          formData.append('id', id);
          formData.append('importType', 2); // 1 = DRY_RUN 2 = IMPORT
          $scope.import2Disabled = true;
          importApi.import(formData).then(
              function(data) {
                  $scope.import2Disabled = false;
                  $scope.importMessage = data.message;
                  $scope.fetch();
              },
              function(message) {
                  $scope.import2Disabled = false;
                  alert(message);
                  $scope.error = true;
                  $scope.importMessage = message;
              }
          );
      };


      $scope.fetch();
    },
  ]);
})(window.angular);

